import styled from 'styled-components'

export const LegalText = styled.p`
  margin-top: 10px;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  color: #000000;
`
